import * as React from 'react';
import { useUIFacade } from '../../../../../ui/facades/ui.facade';
import DateTemplate from '../../../../../ui/templates/columns/DateTemplate';
import LinkTemplate from '../../../../../ui/templates/columns/LinkTemplate';
import ValueTemplate from '../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../ui/widgets/custom/PrwcDataTableAdvanced';

const ShiftCategoryList = (props: any) => {

  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteShiftCategory);
  }
  
  const deleteShiftCategory = (rowData: any) => {
    console.log('delete Attribute --');
    console.log(rowData);
  }

  const editShiftCategory = (rowData: any) => {
    console.log('edit Attribute ---');
    console.log(rowData);
    onEdit(rowData);
  }


  const data = [
    {
      id: 1000,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1001,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1002,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1003,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1004,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1005,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1006,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1007,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1008,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1009,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
    {
      id: 1010,
      name: "Shift Category_One",
      abbreviation: "CATR",
      lastUpdated: "14/2/2020",
    },
  
  ];

  const dataTable = {
    columns: [
      {
        field: "id",
        headerLabelKey: "shiftCategory.label.categoryId",
        bodyTemplate: LinkTemplate,
        className: "w-14 text-xs",
        sortable: true,
        command: (rowData: any) => {
          editShiftCategory(rowData);
        }
      },
      {
        field: "name",
        headerLabelKey: "shiftCategory.label.categoryName",
        bodyTemplate: ValueTemplate,
        className: "w-32 text-xs",
        sortable: true
      },
      {
        field: "abbreviation",
        headerLabelKey: "shiftCategory.label.abbreviation",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "lastUpdated",
        headerLabelKey: "shiftCategory.label.lastUpdated",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
        sortable: true
      }
    ],
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editShiftCategory}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default ShiftCategoryList;
